/**
 * Suppress browser console errors and alerts
 * Shows beautiful toasts instead
 */

// Store original console methods
const originalConsoleError = console.error;
const originalConsoleWarn = console.warn;

// List of error messages to suppress in production
const suppressedErrorPatterns = [
  'Foreign key constraint',
  'Insufficient permissions',
  'permission',
  'Network error',
  'GraphQL Error',
];

/**
 * Check if error should be suppressed
 */
function shouldSuppressError(args) {
  const errorString = args.join(' ').toLowerCase();
  return suppressedErrorPatterns.some(pattern => 
    errorString.includes(pattern.toLowerCase())
  );
}

/**
 * Initialize error suppression
 */
export function initErrorSuppressor() {
  // Only suppress in production
  if (import.meta.env.PROD) {
    // Override console.error to suppress certain errors
    console.error = (...args) => {
      if (!shouldSuppressError(args)) {
        originalConsoleError.apply(console, args);
      }
    };

    // Override console.warn to suppress certain warnings
    console.warn = (...args) => {
      if (!shouldSuppressError(args)) {
        originalConsoleWarn.apply(console, args);
      }
    };
  }
}

/**
 * Restore original console methods (for debugging)
 */
export function restoreConsole() {
  console.error = originalConsoleError;
  console.warn = originalConsoleWarn;
}

export default { initErrorSuppressor, restoreConsole };




